<template>
  <v-layout>
    <v-layout
      v-if="!arrivalPlaces.length"
      row
    >
      <h2 class="mt-2 subheading font-weight-bold">
        Добавить адрес места прибытия
      </h2>
      <v-btn
        class="mt-2 plus-button"
        :disabled="disabled"
        @click="showArrivalPlaceEditor = true"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <v-layout
      v-else
      column
    >
      <v-flex>
        <h2 class="mt-2 subheading font-weight-bold">
          Адреса мест прибытия
        </h2>
      </v-flex>
      <v-flex>
        <template v-for="(place, index) in arrivalPlaces">
          <v-layout
            :key="index"
            align-center
            justify-space-around
          >
            <v-text-field
              :value="place.title"
              label="Место прибытия"
              readonly
              hide-details
              outline
              height="40"
              class="my-2"
            >
              <template v-slot:prepend>
                <ArrivalPlaceNumber :value="index" />
              </template>
            </v-text-field>
            <span v-if="!disabled">
              <MenuRowActions
                class="ma-0"
                :list="rowActions"
                :value="place"
                :index="index"
                @remove="remove"
                @addUp="addUp"
                @addDown="addDown"
                @edit="openEditor"
              />
            </span>
          </v-layout>
        </template>
      </v-flex>
    </v-layout>

    <v-dialog
      :value="showArrivalPlaceEditor"
      persistent
      lazy
      width="1000"
    >
      <v-card>
        <v-card-title class="pb-1">
          <span class="title">Редактирование места прибытия</span>
        </v-card-title>
        <v-card-text>
          <v-flex>
            <v-text-field
              v-model="arrivalPlace.address"
              label="Адрес"
              required
              outline
              height="44"
              @change="entityChange"
            />
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            :loading="loading"
            :disabled="!isValid"
            color="primary"
            @click="save"
          >
            Сохранить
          </v-btn>
          <v-btn
            small
            @click="closeEditor"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import ArrivalPlaceNumber from "./ArrivalPlaceNumber.vue";
import {
  createArrivalPlace,
  deleteArrivalPlace,
  updateArrivalPlace,
} from "../../../../backend/releaseOrdersApi.js";
import * as basErpApi from "../../../../backend/basErpApi.js";
import { unloadingPlaceTypes } from "../../../../enums/unloading-place-types.js";

export default {
  components: {
    ArrivalPlaceNumber,
  },
  props: ["id", "disabled"],
  data() {
    return {
      loading: false,
      showArrivalPlaceEditor: false,
      arrivalType: null,
      arrivalPlace: {
        id: 0,
        order: 0,
        address: null,
      },
      changingArrivalPlaceIndex: null,
      maxArrivalPlaces: 4,
      needSync: false,
    };
  },
  computed: {
    arrivalPlaces() {
      const places = this.$store.getters["releaseOrders/arrivalPlaces"];
      places.forEach((place, index) => {
        place.index = index;
      });
      return places;
    },
    releaseOrder() {
      return this.$store.getters["releaseOrders/releaseOrder"];
    },
    shippingItems() {
      return this.$store.getters["releaseOrders/shippings"];
    },
    arrivalTypeItems() {
      return this.$store.getters["releaseOrders/arrivalTypeItems"];
    },
    isValid() {
      return this.arrivalPlace.address != null;
    },
    unloadingPlaceTypes() {
      return unloadingPlaceTypes;
    },
    rowActions() {
      if (this.arrivalPlaces.length < this.maxArrivalPlaces) {
        return [
          {
            title: "Добавить вверх",
            name: "addUp",
            action: this.addUp,
            type: "icon",
            icon: "north",
            disabled: false,
          },
          {
            title: "Добавить вниз",
            name: "addDown",
            action: this.addDown,
            type: "icon",
            icon: "south",
            disabled: false,
          },
          {
            title: "Изменить",
            name: "edit",
            action: this.openEditor,
            type: "icon",
            icon: "edit",
            disabled: false,
          },
          {
            title: "Удалить",
            name: "remove",
            action: this.remove,
            type: "icon",
            icon: "delete",
            disabled: false,
          },
        ];
      } else {
        return [
          {
            title: "Изменить",
            name: "edit",
            action: this.openEditor,
            type: "icon",
            icon: "edit",
            disabled: false,
          },
          {
            title: "Удалить",
            name: "remove",
            action: this.remove,
            type: "icon",
            icon: "delete",
            disabled: false,
          },
        ];
      }
    },
  },
  methods: {
    entityChange() {
      this.arrivalPlace = {
        id: this.arrivalPlace.id,
        order: this.arrivalPlace.order,
        address: this.arrivalPlace.address,
      };
    },
    async save() {
      this.loading = true;
      if (this.releaseOrder.id) {
        const newArrivalPlace = {
          address: this.arrivalPlace.address,
          order: this.arrivalPlace.order,
        };
        if (this.arrivalPlace.id !== 0) {
          await updateArrivalPlace(
            this.releaseOrder.id,
            this.arrivalPlace.id,
            newArrivalPlace
          );
        } else {
          await createArrivalPlace(this.releaseOrder.id, newArrivalPlace);
        }
        await this.$store.dispatch(
          "releaseOrders/getData",
          this.releaseOrder.id
        );
        await this.$store.dispatch(
          "releaseOrders/getShippings",
          this.releaseOrder.id
        );
        this.needSync = await basErpApi.getNeedSync(this.id);
        this.$store.commit("releaseOrders/setNeedSync", this.needSync);
      } else {
        if (
          this.changingArrivalPlaceIndex === 0 ||
          this.changingArrivalPlaceIndex > 0
        ) {
          const places = this.arrivalPlaces;
          places.splice(this.changingArrivalPlaceIndex, 1, this.arrivalPlace);
          this.$store.dispatch("releaseOrders/initArrivalPlaces", places);
          this.changingArrivalPlaceIndex = null;
        } else {
          const places = this.arrivalPlaces;
          places.push(this.arrivalPlace);
          this.$store.dispatch("releaseOrders/initArrivalPlaces", places);
        }
      }
      this.loading = false;
      this.closeEditor();
    },
    async remove(arrivalPlace) {
      if (this.releaseOrder.id) {
        await deleteArrivalPlace(this.releaseOrder.id, arrivalPlace.id);
        await this.$store.dispatch(
          "releaseOrders/getData",
          this.releaseOrder.id
        );
        await this.$store.dispatch(
          "releaseOrders/getShippings",
          this.releaseOrder.id
        );
      } else {
        const places = this.arrivalPlaces;
        const index = places.indexOf(arrivalPlace);
        places.splice(index, 1);
        this.$store.commit("releaseOrders/setArrivalPlaces", places);
        await this.$store.dispatch(
          "releaseOrders/getShippings",
          this.releaseOrder.id
        );
      }
    },
    openEditor(item, index) {
      this.showArrivalPlaceEditor = true;
      if (!item.id) {
        this.changingArrivalPlaceIndex = index;
      }

      this.arrivalType = item.type ? item.type : null;
      this.arrivalPlace = {
        id: item.id,
        order: item.order,
        address: item.address,
      };
    },
    closeEditor() {
      this.showArrivalPlaceEditor = false;
      this.arrivalType = {
        value: this.unloadingPlaceTypes.FACTORY,
        text: "Склад продавца",
      };
      this.arrivalPlace = {
        id: 0,
        order: 0,
        address: null,
      };
      this.changingArrivalPlaceIndex = null;
    },
    addUp(item) {
      this.showArrivalPlaceEditor = true;
      this.arrivalPlace.order = item.index;
    },
    addDown(item) {
      this.showArrivalPlaceEditor = true;
      this.arrivalPlace.order = item.index + 1;
    },
  },
};
</script>
